import type { Bundle, Condition } from '@medplum/fhirtypes'
import { Diagnosis } from '@seen/core/models/conditions/Diagnosis'

/* bundle-builder.create doesn't set the id on the source Diagnosis — the
   server assigns it and returns the created resource in the bundle. Pull it
   out so consumers get a Diagnosis with .id/.reference accessible. */
export function findCreatedDiagnosis(bundle: Bundle): Diagnosis | undefined {
  const created = bundle.entry?.find(
    (e) => e.resource?.resourceType === 'Condition' && e.resource.id
  )?.resource as Condition | undefined
  return created ? Diagnosis.fromFhirResource(created) : undefined
}
